import { ETimelineType, ETransportationType, ETripEvent } from 'detailsv2/structure';
import i18n from 'i18n';

import { transformTime } from '../../../functions';
import { IDayTripEvent, TimeFormat } from '../../../types';
import { ETransferTypes, EventOptionConfig } from '../../types';

const TransferOption = ({ data, timelineType, timeFormat }: IDayTripEvent<ETripEvent.Transfer> & EventOptionConfig) => {
  const { arrivalTime, departureTime, departureFrom, arrivalTo, displaySettings, transportationType } = data;

  switch (timelineType) {
    case ETimelineType.OneDay:
      return (
        <>
          {getTransferTitle(ETransferTypes.Departure, departureFrom, departureTime, transportationType, {
            displaySettings,
            timeFormat,
          })}
          {getTransferTitle(ETransferTypes.Arrival, arrivalTo, arrivalTime, transportationType, { timeFormat })}
        </>
      );
    case ETimelineType.Start:
      return getTransferTitle(ETransferTypes.Departure, departureFrom, departureTime, transportationType, {
        displaySettings,
        timeFormat,
      });
    case ETimelineType.End:
      return getTransferTitle(ETransferTypes.Arrival, arrivalTo, arrivalTime, transportationType, {
        displaySettings,
        timeFormat,
      });
    default:
      return null;
  }
};

export default TransferOption;

const getTransferTitle = (
  type: ETransferTypes,
  place: string,
  time?: string,
  transportationType?: ETransportationType,
  config: {
    displaySettings?: string;
    timeFormat?: TimeFormat;
  } = {},
) => {
  const transportationTitle = (() => {
    if (transportationType === ETransportationType.RentalCar) {
      return i18n.t('proposal_content.event_details.transfers.rental_car');
    }

    if (transportationType === ETransportationType.Train) {
      return i18n.t('proposal_content.event_details.transfers.train');
    }

    return i18n.t('proposal_content.event_details.transfer');
  })();

  const transferAction = (() => {
    if (type === ETransferTypes.Departure) {
      if (transportationType === ETransportationType.RentalCar) {
        return i18n.t('proposal_content.event_details.transfers.pick_up_at').toLocaleLowerCase();
      }
      return i18n.t('proposal_content.event_details.transfers.departs');
    }

    if (type === ETransferTypes.Arrival) {
      if (transportationType === ETransportationType.RentalCar) {
        return i18n.t('proposal_content.event_details.transfers.drop_off_at').toLocaleLowerCase();
      }
      return i18n.t('proposal_content.event_details.transfers.arrives');
    }

    return '';
  })();

  return (
    <div data-block>
      {config.displaySettings && <div>{config.displaySettings}</div>}
      {time ? `${transformTime(time, config.timeFormat)} - ` : ''}
      {`${transportationTitle} ${transferAction} ${place}`}
    </div>
  );
};
